"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Add_1 = __importDefault(require("../icons/Add"));
var ConversationListItem = (0, react_intl_1.injectIntl)(function (_a) {
    var _b, _c, _d;
    var conversation = _a.conversation, onClick = _a.onClick, hasFocus = _a.hasFocus, intl = _a.intl;
    var title = intl.formatMessage({ id: 'conversationList.title' }, { id: conversation.id });
    var date = intl.formatRelative(((_b = conversation.lastMessage) === null || _b === void 0 ? void 0 : _b.sentOn) || conversation.createdOn);
    var message = ((_d = (_c = conversation.lastMessage) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.text) || '...';
    return (react_1.default.createElement("div", { className: 'bpw-convo-item', onClick: onClick },
        react_1.default.createElement("div", { className: 'bpw-align-right' },
            react_1.default.createElement("div", { className: 'bpw-title' },
                react_1.default.createElement("div", null, title),
                react_1.default.createElement("div", { className: 'bpw-date' },
                    react_1.default.createElement("span", null, date))),
            react_1.default.createElement("div", { className: 'bpw-convo-preview' }, message))));
});
var ConversationList = /** @class */ (function (_super) {
    __extends(ConversationList, _super);
    function ConversationList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focusIdx: undefined
        };
        _this.changeFocus = function (step) {
            var focusIdx = _this.state.focusIdx || 0;
            focusIdx += step;
            if (focusIdx > _this.props.conversations.length) {
                focusIdx = 0;
            }
            else if (focusIdx < 0) {
                focusIdx = _this.props.conversations.length;
            }
            _this.setState({ focusIdx: focusIdx });
        };
        _this.handleKeyDown = function (e) {
            if (!_this.props.enableArrowNavigation) {
                return;
            }
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                _this.changeFocus(1);
            }
            else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                _this.changeFocus(-1);
            }
            else if (e.key === 'Enter' && _this.state.focusIdx && _this.state.focusIdx < _this.props.conversations.length) {
                var convoId = _this.props.conversations[_this.state.focusIdx].id;
                _this.props.fetchConversation.bind(_this, convoId);
            }
        };
        return _this;
    }
    ConversationList.prototype.componentDidMount = function () {
        this.main.focus();
    };
    ConversationList.prototype.componentDidUpdate = function (_, prevState) {
        if (this.state.focusIdx === this.props.conversations.length) {
            this.btn.focus();
        }
        else if (prevState.focusIdx === this.props.conversations.length) {
            this.main.focus();
        }
    };
    ConversationList.prototype.render = function () {
        var _this = this;
        var _a = this.props, conversations = _a.conversations, createConversation = _a.createConversation, fetchConversation = _a.fetchConversation;
        return (react_1.default.createElement("div", { tabIndex: 0, ref: function (el) { return (_this.main = el); }, className: 'bpw-convo-list', onKeyDown: this.handleKeyDown },
            conversations.map(function (convo, idx) { return (react_1.default.createElement(ConversationListItem, { key: convo.id, hasFocus: _this.state.focusIdx === idx, conversation: convo, onClick: fetchConversation.bind(_this, convo.id) })); }),
            react_1.default.createElement("button", { ref: function (el) { return (_this.btn = el); }, id: "btn-convo-add", className: 'bpw-convo-add-btn', onClick: createConversation.bind(this, undefined) },
                react_1.default.createElement(Add_1.default, { width: 15, height: 15 }))));
    };
    return ConversationList;
}(react_1.default.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        conversations: store.conversations,
        createConversation: store.createConversation,
        fetchConversation: store.fetchConversation,
        enableArrowNavigation: store.config.enableArrowNavigation
    });
})((0, react_intl_1.injectIntl)((0, mobx_react_1.observer)(ConversationList)));
